import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Logout.css'; // 🎯 Stil dosyasını ekledik

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // İsteğe bağlı: API logout çağrısı yapabilirsiniz.
      // await fetch('https://apiportal.mbsays.com/public/api/logout', {
      //   method: 'POST',
      //   headers: {
      //     'Authorization': `Bearer ${sessionStorage.getItem('authToken')}`,
      //     'Content-Type': 'application/json'
      //   }
      // });

      // SessionStorage'dan token ve kullanıcı bilgisini kaldırıyoruz
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('user');
      sessionStorage.clear();
      // Kullanıcıyı login sayfasına yönlendiriyoruz
      navigate('/login');
      // Yönlendirme sonrası sayfayı yenile
    setTimeout(() => {
      window.location.reload();
    }, 100); // kısa bir gecikme yönlendirme için
    } catch (error) {
      console.error('Çıkış yapma hatası:', error);
    }
  };

  return (
    <button onClick={handleLogout} className="logout-button">
      <img src="/exit.svg" alt="Exit" />
    </button>
  );
};

export default Logout;
